import { key } from 'core-ts-types';
import { merge } from 'lodash4';
import { planFeedbackTransactionType } from './plan_feedback_transaction_type';

export interface IAPBaseTerm {
  cat_yr: number;
  id: number;
  name: string;
  nk: string;
  registration_end_dt: string;
  registration_start_dt: string;
  term_end_dt: string;
  term_start_dt: string;
  term_type: null;
}

export interface IPlanFeedbackTerm {
  diff: planFeedbackTransactionType;
  id: key;
  nk: string;
  term: IAPBaseTerm;
  from_term: IAPBaseTerm;
  resolution: number | null;
}

export class PlanFeedbackTerm implements IPlanFeedbackTerm {
  term: IPlanFeedbackTerm['term'];
  from_term: IPlanFeedbackTerm['from_term'];
  diff: IPlanFeedbackTerm['diff'];
  id: IPlanFeedbackTerm['id'];
  nk: IPlanFeedbackTerm['nk'];
  resolution: IPlanFeedbackTerm['resolution'];

  constructor(planFeedbackTerm: Partial<PlanFeedbackTerm>) {
    merge(this, planFeedbackTerm);
    if (this.diff === 'REMOVE') {
      this.term = this.from_term;
    }
  }

  static build(inTakeSurveyPoll: Partial<PlanFeedbackTerm>): PlanFeedbackTerm {
    return new PlanFeedbackTerm(inTakeSurveyPoll);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/builders/plan_feedback_term_builder.ts